import React, {useCallback, useEffect, useState} from "react";
import ListFormComponent from "../../components/ListFormComponent";
import CSVPage from "./CSVPage";
import ProjectPage from "./ProjectPage";
import WorkflowPage from "../../pages/WorkflowPage";
import TotalFormComponent from "../../components/TotalFormComponent";
import ProjectMapPage from "./ProjectMapPage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "antd";
import axios from "axios";
import {useAxios} from "../../hooks/hooks";

// TODO: separate combined register component

function HomePage(props) {
    const axios = useAxios();
  const CancelToken = axios.CancelToken;

  const [forbidden, setForbidden] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);


  const downloadCombinedRegister = useCallback(async () => {
    var rows = [];
    var url =
      "combined-register?" +
      "order[0]=internal_external&" +
      "order[1]=building&" +
      "order[2]=level&" +
      "order[3]=room&" +
      "order[4]=type_of_hazmat&" +
      "page_size=1000&page=1&filter[id_company]=" +
      props.userProfile.id_company.toString();
    const response = await axios.current.get(url);
    rows = response.data.rows;
    if (rows.error) {
      setError(JSON.stringify(rows.error));
      return null;
    }
    // Create csv

    if (rows.length === 0) return;
    let csv =
      "data:text/csv;charset=utf-8," +
      '"TO ENSURE ITS CONTEXTUAL INTEGRITY, ADE RECOMMENDS ALL DATA IS READ IN ITS ENTIRETY AND SHOULD NOT BE COPIED, DISTRIBUTED OR REFERRED TO IN PART ONLY."\n' +
      "Project ID, Internal/External, Building, Level, Room, Material Type Description, Type of HAZMAT, Quantity, Units, Photo Number, Sample Number, Analytical Results, Friability, Accessibility, Condition, Risk Score, Control Recommendations / Comments, Review Date\n" +
      rows
        .map((e) => {
          return [
            e.id_project,
            e.internal_external,
            e.building,
            e.level,
            e.room,
            e.material_type_description,
            e.type_of_hazmat,
            e.quantity,
            e.unit,
            e.photo_number,
            e.sample_number,
            e.analytical_results,
            e.friability,
            e.accessibility,
            e.condition,
            e.risk_score,
            e.control_recommendations,
            e.review_date,
          ]
            .map((e) => '"' + e + '"')
            .join(",");
        })
        .join("\n");

    var encodedUri = encodeURI(csv);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "register_" + rows[0].name_company + ".csv");
    document.body.appendChild(link);
    link.click();
  }, [setError, props.userProfile.id_company]);

  if (undefined !== props.userProfile.endpoints.CT) {
    return (
      <>
        <h2>Customer Indicators</h2>
        <ProjectMapPage {...props}></ProjectMapPage>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: 18,
            marginBottom: 18,
          }}
        >
          <Button style={{ margin: 10 }} onClick={downloadCombinedRegister}>
            <FontAwesomeIcon icon="file" />
            &nbsp;Download Combined Register
          </Button>
          <div style={{ fontSize: 12, color: "#555555" }}>
            TO ENSURE ITS CONTEXTUAL INTEGRITY, ADE RECOMMENDS ALL DATA IS READ
            IN ITS ENTIRETY AND SHOULD NOT BE COPIED, DISTRIBUTED OR REFERRED TO
            IN PART ONLY.
          </div>
        </div>
        <ListFormComponent
          create={false}
          home="/dashboard/"
          endpoint={props.endpoints["customer-projects"].list}
          history={props.history}
        />
      </>
    );
  }

  if (
    undefined === props.endpoints.coc ||
    undefined === props.endpoints.projects
  ) {
    return (
      <>
        <WorkflowPage {...props} />
      </>
    );
  }

  if (props.currentProject && props.projectMode === true) {
    return (
      <>
        <ProjectPage {...props} />
      </>
    );
  } else {
    return (
      <>
        <CSVPage {...props} />
      </>
    );
  }
}

export default HomePage;
